

import JSON from "./lib/stringify"; 
import {json_parse} from "./lib/parse";

const jsonBigInt = (options) => ({
    parse: json_parse(options),
    stringify: JSON.stringify
})

const defaultBigInt = jsonBigInt();

defaultBigInt.parse = json_parse();
defaultBigInt.stringify = JSON.stringify;

export default jsonBigInt;
export const parse = defaultBigInt.parse;
export const stringify = defaultBigInt.stringify;

/* 
var json_stringify = require('./lib/stringify.js').stringify;
var json_parse     = require('./lib/parse.js');

module.exports = function(options) {
    return  {
        parse: json_parse(options),
        stringify: json_stringify
    }
};
//create the default method members with no options applied for backwards compatibility
module.exports.parse = json_parse();
module.exports.stringify = json_stringify; */

